import LoginComponent from "../components/dt/login_114.vue";

const Loging = {
    install:function(Vue){
        Vue.component("Loging",LoginComponent);
    }
}
export default Loging;


// WEBPACK FOOTER //
// ./src/plugins/loging.js